import { useAuth } from '@/app/context';
import {
  AuthHeader,
  ExpiredLinkMessage,
  RequestNewLinkForm,
  SuccessMessage,
} from '@/features/auth/components';
import { LoadingSpinner } from '@/shared/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/_auth/expired-link')({
  component: ExpiredLinkPage,
  pendingComponent: LoadingSpinner,
});

function ExpiredLinkPage() {
  const [showForm, setShowForm] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { requestNewLink, loading } = useAuth();

  const handleRequestNewLink = () => {
    setShowForm(true);
  };

  const handleSubmit = async (email: string) => {
    const result = await requestNewLink(email);
    if (result.isLinkRequested) {
      setSuccess(true);
    } else {
      setError(result.message);
    }
  };

  if (success) {
    return (
      <SuccessMessage
        title='Link enviado!'
        message='Por favor, verifique seu e-mail para acessar o novo link'
        buttonText='Voltar ao login'
        buttonLink='/login'
      />
    );
  }

  if (showForm) {
    return (
      <>
        <AuthHeader
          title='Solicitar novo link'
          subtitle='Informe seu endereço de e-mail para receber um novo link de acesso.'
        />

        <RequestNewLinkForm
          onSubmit={handleSubmit}
          loading={loading}
          error={error}
        />
      </>
    );
  }

  return (
    <ExpiredLinkMessage
      onRequestNewLink={handleRequestNewLink}
      loading={loading}
    />
  );
}
